import React, { Component, PropTypes } from 'react';

// Import InviteCell component.
import InviteCell from './InviteCell.js';
import './InviteList.css';

class InviteList extends Component {
  renderInvite(invite) {
    return (
      <InviteCell key={invite.id} invite={invite} />
    )
  }

  render() {
    if (this.props.invites.length === 0) {
      return <div>You haven’t invited anyone yet</div>;
    }
    return (
      <table className="InviteList">
        <tbody>
          {this.props.invites.map((invite) => this.renderInvite(invite))}
        </tbody>
      </table>
    );
  }
}

InviteList.propTypes = {
  invites: PropTypes.array.isRequired
};

export default InviteList;



// WEBPACK FOOTER //
// ./src/components/InviteList.js